import { useTranslation } from "react-i18next";

const MerchantStatusOptions = (list) => {
  const { t } = useTranslation();
  const options = [
    {
      key: "pending",
      title: t("options.merchantStatus.pending"),
      value: "PENDING",
    },
    {
      key: "active",
      title: t("options.merchantStatus.active"),
      value: "ACTIVE",
    },
    {
      key: "suspended",
      title: t("options.merchantStatus.suspended"),
      value: "SUSPENDED",
    },
    {
      key: "terminated",
      title: t("options.merchantStatus.terminated"),
      value: "TERMINATED",
    },
  ];

  if (typeof list === "string" && list.toLowerCase() === "all") {
    return options;
  }
  if (Array.isArray(list)) {
    const newOptions = [];
    for (const item of list) {
      const newOption = options.find(
        (option) => item === option.value || item === option.key.toLowerCase(),
      );
      newOptions.push(newOption);
    }
    return newOptions;
  }
  return [];
};

export default MerchantStatusOptions;
